module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921062334_T.901402dd.jpg";